<template>
  <main class="hero">
    <div class="heading">
      {{ heading }}
    </div>
    <div class="p-container">
      <p v-html="paragraph" class="paragraph"></p>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Hero',
  props: {
    heading: {
      type: String,
      required: true
    },
    paragraph: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
.heading {
  margin: 0;
  color: var(--color-title);
  font-family: var(--primary-ff);
  font-weight: 500;
  font-size: var(--fs-4);
  padding-bottom: 0.5em;
}

.paragraph {
  margin: 0;
  color: var(--color-body);
  font-family: var(--primary-ff);
  font-weight: 500;
  font-size: var(--fs-3);
  line-height: 1.35em;
}

/* Mobile */
@media (max-width: 400px) {
  .heading {
    font-size: var(--fs-4m);
  }

  .paragraph {
    font-size: var(--fs-3m);
  }
}
</style>
